import { render, staticRenderFns } from "./gzzoc-hepatobiliary-pdf.vue?vue&type=template&id=cb1a84f4&scoped=true&lang=pug&"
import script from "./gzzoc-hepatobiliary-pdf.vue?vue&type=script&lang=js&"
export * from "./gzzoc-hepatobiliary-pdf.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-hepatobiliary-pdf.vue?vue&type=style&index=0&id=cb1a84f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a84f4",
  null
  
)

export default component.exports